import React, {useEffect, useState} from "react";
import UploadPhoto from "../../component/UploadPhoto/UploadPhoto";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {MagazineService} from "../../serverService/magazineService/MagazineService";
import {useParams} from "react-router-dom";
import {
    RaikoBaseCardContainer,
    RaikoButtonPrimary,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn, RaikoMagazineThumbnailUpload, RaikoSectionContainer,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";

export default function NewsDetailThumbnail({blogID}) {

    const service = new MagazineService()
    const [thumbnailLoading, setThumbnailLoading] = useState(false);


    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof blogID !== "undefined" && blogID >= 0) {
            getNewsInfoFromServer()
        }
    }, [blogID])


    const [thumbnailFile, setThumbnailFile] = useState()
    const [thumbnailImage, setThumbnailImage] = useState()


    function getNewsInfoFromServer() {
        setThumbnailLoading(true)
        service.getThumbnailInfo(blogID)
            .then(response => {
                if (response.downloadUrl && response.downloadUrl.length > 0) {
                    setThumbnailImage(response.downloadUrl)
                }
            }).catch(reason => {
            showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت تصویر شاخص"))
        }).finally(_ => {
            setThumbnailLoading(false);
        })
    }

    function handleUpdateThumbnail() {
        if (thumbnailFile) {
            setThumbnailLoading(true)
            service.updateThumbnail(blogID, thumbnailFile)
                .then(() => {
                    showSuccessMessage("تصویر شاخص با موفقیت بروزرسانی شد.")
                }).catch(reason => {
                showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی تصویر شاخص"))
            }).finally(_ => {
                setThumbnailLoading(false)
            })
        } else {
            showWarningMessage("لطفا ابتدا فایل تصویر شاخص را انتخاب نمایید.")
        }
    }

    function handleChooseImage(file, preview) {
        setThumbnailImage(preview)
        setThumbnailFile(file)
    }

    return (
        <RaikoBaseCardContainer>
            <RaikoSectionContainer
                title={"تصویر شاخص"}
                subTitle={"تصویر شاخص نمایش داده شده برای کاربران"}
                hasActionButton
                actionButtonOnclick={handleUpdateThumbnail}
                actionButtonLoadingState={thumbnailLoading}
            >
                {/*<UploadPhoto
                    photoFile={photoFile}
                    setPhotoFile={setPhotoFile}
                    photo={photoUrl}
                    setPhoto={setPhotoUrl}
                />
                <RaikoFlexAlignEnd>
                    <RaikoButtonPrimary label={"بروزرسانی"} onClick={handleUpdateThumbnail}/>
                </RaikoFlexAlignEnd>*/}

                <RaikoMagazineThumbnailUpload
                    ASPECT_RATIO={3 / 2}
                    avatarFile={thumbnailImage}
                    updateAvatar={handleChooseImage}
                />
            </RaikoSectionContainer>
        </RaikoBaseCardContainer>
    )
}